import type { DataImportValidateMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DataImportValidateDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * NOTE: the tRPC path is ASYNC — it resolves as soon as the validation
 * pipeline has been kicked off (status moves to 'validating' and the results
 * page's status subscription shows live progress), whereas the legacy Hasura
 * action ran validation synchronously. Consumers must not assume validation
 * is complete when the promise resolves.
 */
export const useDataImportValidate = createMutationHook({
  name: 'dataImportValidate',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.dataImport.validate.mutationOptions({ onSuccess }),
  mapInput: (id: string) => ({ id }),
  invalidate: (trpc) => [
    trpc.frontend.dataImport.dataImports.queryKey(),
    trpc.frontend.dataImport.dataImportById.queryKey(),
  ],
  mapResponse: (result: { message: string }): DataImportValidateMutation => ({
    dataImportValidate: {
      __typename: 'DataImportValidateOutput',
      message: result.message,
    },
  }),
  graphqlDocument: DataImportValidateDocument,
  graphqlVariables: (id: string) => ({ Id: id }),
  evictFields: ['data_import'],
});
